import InputSearch from './input-search';

export default InputSearch;
